import { useAppData } from '../state/AppDataProvider';
import { currentPlan, nextPlan } from '../state/plan-service';
import type { Action } from '../state/reducer';
import { usePlanEdits } from '../state/use-plan-edits';

/**
 * DE: Kalender ändern (Bundesland, Ruhetage) und die offenen Einkäufe des laufenden und des
 * nächsten Plans neu legen.
 * EN: Change the calendar (federal state, closed days) and move the open trips of the running and
 * the next plan.
 */
export function useCalendarChange(): (action: Action) => void {
  const { data, dispatch, today } = useAppData();
  const plans = usePlanEdits();
  return (action) => {
    // DE: Die Rechnung liest die neuesten Daten, also schon mit dem geänderten Kalender.
    // EN: The calculation reads the newest data, so the changed calendar is already in it.
    dispatch(action);
    for (const stored of [currentPlan(data, today), nextPlan(data, today)]) {
      if (stored) void plans.edit({ kind: 'recalculate-trips', planStart: stored.period.start });
    }
  };
}
